import { Sparkles, Square } from "lucide-react";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";
import { useStream } from "@/lib/useStream";

const FIELDS = ["name", "category", "materials", "size", "care", "dog_size", "verdict"];

export const copyFacts = (p) => ({ ...Object.fromEntries(FIELDS.map((k) => [k, p[k] || ""])), price: Number(p.price) || null, current: p.description || "" });

// Streams Claude's draft for one field ("description" or "verdict") straight into the product form.
export const useClaudeField = (p, set, kind) => {
  const { busy, run, stop } = useStream();
  const write = async () => {
    try {
      const text = await run(`/admin/ai/${kind}`, copyFacts(p), (t) => set(kind, kind === "verdict" ? t.trim() : t));
      if (text) toast.success("Draft ready. Edit it, then press Save");
    } catch (e) {
      toast.error(e.message);
    }
  };
  return { busy, toggle: busy ? stop : write };
};

export const AiDescription = ({ p, set }) => {
  const { busy, toggle } = useClaudeField(p, set, "description");
  return (
    <div className="sm:col-span-2 text-sm">
      <div className="flex items-center justify-between gap-3">
        <span className="font-medium">Description</span>
        <button
          type="button"
          data-testid={busy ? ADMIN.aiStop(p.slug) : ADMIN.aiWrite(p.slug)}
          onClick={toggle}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#1C1917] text-white text-xs font-semibold hover:bg-stone-700 active:scale-95 transition-[background-color,transform]"
        >
          {busy ? <><Square size={12} /> Stop</> : <><Sparkles size={13} /> Write with Claude</>}
        </button>
      </div>
      <textarea data-testid={ADMIN.descriptionInput(p.slug)} value={p.description || ""} onChange={(e) => set("description", e.target.value)} rows={5} placeholder="What shoppers read on the product page" className="w-full mt-1 px-3 py-2 rounded-xl border border-[#E7E0D3] bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#E06D44]/40" />
      <p className="text-xs text-stone-500 mt-1">Claude drafts from the name, specs and Kiddee's verdict. Check the facts before saving.</p>
    </div>
  );
};

export const AiVerdictButton = ({ p, set }) => {
  const { busy, toggle } = useClaudeField(p, set, "verdict");
  return (
    <button
      type="button"
      data-testid={ADMIN.aiVerdict(p.slug)}
      onClick={toggle}
      title={busy ? "Stop" : "Suggest a Kiddee verdict with Claude"}
      aria-label={busy ? "Stop Claude" : `Suggest a Kiddee verdict for ${p.name}`}
      className={`absolute right-1.5 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full grid place-items-center transition-colors ${busy ? "bg-[#1C1917] text-white" : "text-[#E06D44] hover:bg-[#F0EBE1]"}`}
    >
      {busy ? <Square size={11} /> : <Sparkles size={14} />}
    </button>
  );
};
